<template>
  <div class="result">
    <result-header />
    <result-chart />
    <result-share />
  </div>
</template>

<style lang="scss">
.result {
  width: 100%;
}
</style>

<script>
import Chart from '@/components/Result/Bside.vue';
import Header from '@/components/Result/Header.vue';

export default {
  created() {
    this.$store.dispatch('income/setIncome', this.$route.params.income);
  },
  components: {
    'result-chart': Chart,
    'result-header': Header,
    'result-share': () => import('@/components/Share.vue'),
  },
};
</script>
